import { ArticleAttributeFilter } from '@generated'

// These attributes should always be filtered out, they should never be visible to the user
const excludedNames = ['isMemberonlyDiscount', 'priceCategory', 'isServicePerformed']

/**
 * Filters out specific attributes from an array of ArticleAttributeFilter objects
 * @param attributes - Array of ArticleAttributeFilter objects to apply filters to
 * @param extraAttributesToFilter - Additional attribute names to exclude from the results
 * @returns Filtered array of ArticleAttributeFilter objects, excluding priceCategory, attributes starting with '_',
 * and any names specified in extraAttributesToFilter
 */
export const getFilteredAttributes = (
  attributes: ArticleAttributeFilter[],
  extraAttributesToFilter: string[] = [],
) => {
  return attributes.filter(
    (attribute) =>
      attribute.attributeName &&
      !excludedNames.includes(attribute.attributeName) &&
      !extraAttributesToFilter.includes(attribute.attributeName) &&
      !attribute.attributeName.startsWith('_'),
  )
}
